import { gql } from "@apollo/client";

const InsertQuery = gql`
mutation InsertGogasReferralReg($object: gogas_referral_registrations_insert_input = {}) {
  insert_gogas_referral_registrations_one(object: $object, on_conflict: {constraint: gogas_referral_registrations_phone_number_key, update_columns: [name, vehicle_type, vehicle_number]}) {
    id
  }
}
`

export const InsertGogasReferralReg = async (
    data,
    client,
) => {
    let resp;
    try {
        // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
        // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id

        resp = await client.mutate({
            mutation: InsertQuery,
            // refetchQueries: [getQuery],
            variables: {
                "object": {
                    "name": data?.name,
                    "phone_number": data?.phone_number,
                    "referred_by": data?.mobile,
                    "referred_user_id": parseInt(data?.user_id),
                    "vehicle_type": data?.vehicle_type,
                    "vehicle_number": data?.vehicle_number,
                    "mobile_type": data?.mobile_type,
                    "city": data?.city
                }
            },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    //   "x-hasura-admin-secret": "aseraadmin@1234",
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
                },
            },
        });
        if (resp.errors) {
            return { success: false }
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
        // showFailureAlert('Something went wrong while updating your cart');
    }
    return { success: true, data: resp.data }
};